import configs from './config.json';
import {Api} from "./Api";
import {UserApi} from "./UserApi";

export class NewsApi {


    static getNews = async (data, response, error) => {
        await Api.get(`${configs.news.news}/${data}`, null, response, UserApi.getAuthorizedHeader(), error);

    }

    static getAllNews = async (data, response, error) => {
        await Api.get(`${configs.news.all}/${data}`, null, response, UserApi.getAuthorizedHeader(), error);
    }

    static insertNews = async (data, response, error) => {
        await Api.post(`${configs.news.news}`, data, response, UserApi.getAuthorizedHeader(), error);

    }

    static updateNews = async (data, id, response, error) => {
        await Api.put(`${configs.news.news}/${id}`, data, response, UserApi.getAuthorizedHeader(), error);

    }

    static deleteNews = async (id, response, error) => {
        await Api.delete(`${configs.news.news}/${id}`, null, response, UserApi.getAuthorizedHeader(), error);
    }

}